// App
import React from 'react';

// Constellation
import { IconPhotosOutline } from '@zillow/constellation';

// Types
type BubbleWindowPropTypes = {
  propertyPhotos: Array<{ medium: string }> | null;
  beds: number | null;
  baths: number | null;
  sqft: string | null;
  bubblePrice: string | null;
};

import * as S from './styles';

/**
 * BubbleWindow is the child component of zilow-map-control bubbles. When a marker is hovered,
 * the zrc bubble will render the info window that contains home listing information.
 */
const BubbleWindow = ({ propertyPhotos, beds, baths, sqft, bubblePrice }: BubbleWindowPropTypes) => {
  const propertyPhoto = propertyPhotos && propertyPhotos[0] && propertyPhotos[0].medium;

  return (
    <S.Window>
      <S.ContentContainer>
        <S.InfoThumbContainer>
          {propertyPhoto ? <S.Thumbnail src={propertyPhoto} /> : <IconPhotosOutline size="sm" fontColor="gray100" />}
        </S.InfoThumbContainer>
        <S.Details>
          <S.DetailsText fontType="finePrint" as="strong">
            {bubblePrice}
          </S.DetailsText>
          <S.DetailsText fontType="finePrint">
            {beds} bed, {baths} ba
          </S.DetailsText>
          <S.DetailsText fontType="finePrint">{`${sqft ? sqft : '—'} sqft`}</S.DetailsText>
        </S.Details>
      </S.ContentContainer>
    </S.Window>
  );
};

export default BubbleWindow;
